// extracted by css-extract-rspack-plugin
export default {"supportingText":"supportingText-VWdeCO","invalid":"invalid-kbMnAW"};